import styled, { css } from 'styled-components';

import {
  CheckBoxFieldTheme,
  CheckBoxWrapperPropsType,
  StyledCheckBoxPropsType,
} from './CheckBoxField.types';
import { withMargin } from 'style-utils/withStyledProps/withMarginProps';
import { getThemeColor } from 'style-utils/theme/utils/getThemeColor';

export const CheckBoxWrapper = styled.div<CheckBoxWrapperPropsType>`
  display: inline-flex;
  justify-content: center;
  ${withMargin};
  ${({ theme }: { theme: CheckBoxFieldTheme }) => theme.checkBoxWrapper?.style}
  ${({ labelPosition }: CheckBoxWrapperPropsType) => {
    switch (labelPosition) {
      case 'TOP':
        return css`
          flex-direction: column-reverse;
        `;
      case 'BOTTOM':
        return css`
          flex-direction: column;
        `;
      case 'LEFT':
        return css`
          flex-direction: row-reverse;
        `;
      default:
        return css`
          flex-direction: row;
        `;
    }
  }}
`;

export const StyledCheckBox = styled.input<StyledCheckBoxPropsType>`
  position: relative;
  appearance: none;
  border: 2px solid ${getThemeColor('checkboxBorder')};
  min-height: 2rem;
  min-width: 2rem;
  cursor: pointer;
  &:checked {
    &::after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: url(${({ icon }: StyledCheckBoxPropsType) => icon}) no-repeat
        center;
    }
  }
  ${({ theme }: { theme: CheckBoxFieldTheme }) => theme.checkBoxInput?.style}
`;

export const CheckBoxLabel = styled.label`
  ${({ theme }: { theme: CheckBoxFieldTheme }) => theme.checkBoxLabel?.style}
`;
